import { useLocation } from 'react-router-dom';
import DocumentTitle from './DocumentTitle.js';

/** Per-path SEO: longer titles + meta descriptions for key articles */
const ROUTE_SEO = {
  '/blog/ai-transforming-software-development': {
    title: 'How AI Is Transforming Software Development',
    description:
      'How AI is changing software development: code generation, testing, reviews, and delivery. Practical trends, risks, and how teams use assistants like Zolaid to ship faster.',
  },
  '/blog/team-collaboration-with-zolaid': {
    title: 'Team Collaboration with Zolaid',
    description:
      'Team collaboration with Zolaid: shared context, workspace and chat in one flow, integrations, and rituals that keep product and engineering aligned.',
  },
  '/blog/security-best-practices-ai-development': {
    title: 'Security Best Practices for AI Development',
    description:
      'Security best practices for AI-assisted development: data and prompt boundaries, code review, secrets, supply chain, access control, and governance.',
  },
};

const ROUTE_TITLES = {
  '/': null,
  '/chatbot': 'Chat',
  '/chatbot-page': 'Chat',
  '/pricing': 'Pricing',
  '/success': 'Success',
  '/Features': 'Features',
  '/Enterprise': 'Enterprise',
  '/Resources': 'Resources',
  '/Roadmap': 'Roadmap',
  '/docs': 'Docs',
  '/ide': 'IDE',
  '/TechArticlesPage': 'Tech Articles',
  '/Blog': 'Blog',
  '/Support': 'Support',
  '/About': 'About',
  '/about': 'About',
  '/Careers': 'Careers',
  '/Teams': 'Teams',
  '/Education': 'Education',
  '/Integrations': 'Integrations',
  '/Apps': 'Apps',
  '/Overview': 'Overview',
  '/Download': 'Use Zolaid in your browser',
  '/Contact': 'Contact',
  '/PrivacyPolicy': 'Privacy Policy',
  '/TermsOfService': 'Terms of Service',
  '/delete-data': 'Data Deletion',
  '/login': 'Login',
  '/auth': 'Auth',
  '/Templates': 'Templates',
  '/Moderation': 'Moderation',
  '/Projects': 'Projects',
  '/Campaigns': 'Campaigns',
  '/Impact': 'Impact',
};

export default function RouteTitle() {
  const { pathname } = useLocation();
  const seo = ROUTE_SEO[pathname];
  const title = seo?.title ?? ROUTE_TITLES[pathname] ?? null;
  const description = seo?.description ?? null;
  return <DocumentTitle title={title} description={description} />;
}
